export default "__VITE_ASSET__DnyuRSkH__"